import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {ImageEntity} from "../../../shared/entities/image/image.entity";
import {AbstractForm} from "../../shared/form/abstract.form";

/**
 * The Image Content Form, containing the form group and image entity
 * @extends {AbstractForm}
 *
 * @description Defines the image form fields' values and config
 */
export class ImageContentForm extends AbstractForm {

  /**
   * The form containing each piece of metadata
   * @protected
   * @type {FormGroup}
   */
  protected form: FormGroup;

  /**
   * The full_name of this form to be passed to Prism
   * @type {string}
   * @protected
   */
  protected formName: string = 'mobile_images[images][0]';

  /**
   * Call super class
   * @param {FormBuilder} formBuilder The FormBuilder instance
   * @param {ImageEntity} abstractEntity The entity inside of this form
   * @constructor
   */
  constructor(protected formBuilder: FormBuilder,
              public abstractEntity: ImageEntity) {
    super(formBuilder, abstractEntity);
  }

  /**
   * Get the FormGroup of this form
   * @returns {FormGroup}
   */
  getForm(): FormGroup {
    return this.form;
  }

  /**
   * Get the entity from the form
   * @returns {ImageEntity}
   */
  getEntity(): ImageEntity {
    return this.abstractEntity;
  }

  /** @inheritdoc */
  getValue(): {} {

    let original;
    const formValue = this.getForm().getRawValue();
    const formData = {};
    const newFormData = {};
    formData[this.abstractEntity.getTitle().getName()] = formValue.title;
    formData[this.abstractEntity.getAlt().getName()] = formValue.title;
    formData[`${this.formName}[id]`] = formValue.id;
    formData[this.abstractEntity.getCaption().getName()] = formValue.caption;
    formData[this.abstractEntity.getCredits().getName()] = formValue.credits;
    formData[`${this.abstractEntity.getKeywords().getName()}[]`] = formValue.keywords && formValue.keywords[0] && formValue.keywords.split(',') || '';
    formData[this.abstractEntity.getCropGravity().getName()] = formValue.cropGravity;
    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        original = key;
        newFormData[key.replace(/\[\d+\]/, '[0]')] = formData[original];
      }
    }
    return newFormData;
  }

  /** @inheritdoc */
  protected getFormConfig(): {} {
    return {
      caption: new FormControl(this.abstractEntity.getCaption().getValue()),
      credits: new FormControl(this.abstractEntity.getCredits().getValue()),
      cropGravity: new FormControl(this.abstractEntity.getCropGravity()),
      id: this.abstractEntity.getId(),
      keywords: new FormControl(this.abstractEntity.getKeywords().getValue().join(',')),
      title: new FormControl(this.abstractEntity.getTitle().getValue()),
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/content/image/form/image-content.form.ts